/**
 * Import Dependency
 */
// import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
// import * as stepperActions from '../../actions/components/stepper'
// import * as optionGroupsActions from '../../actions/components/optionGroups'

/**
 * Import Component
 */
import CategoryDetail from '../../components/CategoryDetail'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {
    user: state.user,
    merchant: state.merchant,
    stash: state.stash,
    orders: state.orders,
    stashByOptionGroups: state.stashByOptionGroups,
    selectedCategory: state.selectedCategory,
    isStickyNavbarSwiper: state.isStickyNavbarSwiper,
  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
)(injectIntl(CategoryDetail)))



// WEBPACK FOOTER //
// ./src/containers/components/CategoryDetail.js